const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净观影',
    desc: '全站无弹窗广告、无恶意跳转，纯净观影环境。所有资源经过安全检测，保护你的设备与隐私安全。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速高清播放',
    desc: '智能CDN加速与多线路自动切换技术，保障1080P至4K画质流畅不缓冲，观影体验媲美本地播放。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容覆盖',
    desc: '片库收录超两万部影视作品，涵盖电影、电视剧、综艺、动漫、纪录片等15个分类，每日持续更新。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            平台优势
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8 text-center group hover:border-primary-300/50 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto rounded-2xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mt-5">
                {feat.title}
              </h3>
              <p className="text-foreground-500 text-sm mt-2 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}